import React, { useEffect, useState } from 'react';
import { Switch, Modal } from 'antd';
import {
  useSwitchEnableQuestsMutation,
  useUserScenesQuery,
} from '../../generated/graphql';
import QuestSettings from './QuestSettings';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import styles from './quests.module.css';

const { confirm } = Modal;

const Quests = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [switchEnableQuestM] = useSwitchEnableQuestsMutation();
  const router = useRouter();
  const sceneId = Array.isArray(router.query?.id)
    ? router.query?.id[0]
    : router.query?.id;

  const { data: scene } = useUserScenesQuery({
    variables: {
      where: {
        id: {
          equals: sceneId as string,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (scene?.userScenes[0].hasQuest) {
      setIsChecked(true);
    }
  }, [scene?.userScenes[0].hasQuest]);

  const showConfirmModal = () => {
    return new Promise((resolve) => {
      confirm({
        title: 'Confirm',
        icon: <ExclamationCircleOutlined />,
        content:
          'You are about to make the quest public accessible for everybody.',
        okText: 'Ok',
        cancelText: 'Cancel',
        onOk() {
          resolve(true);
        },
        onCancel() {
          resolve(false);
        },
      });
    });
  };

  async function switchEnableQuest(checked: boolean) {
    if (checked) {
      const isConfirmed = await showConfirmModal();

      if (!isConfirmed) {
        setIsChecked(false);
        return;
      }

      setIsChecked(true);
    }

    if (!checked) {
      setIsChecked(false);
    }
    await switchEnableQuestM({
      variables: {
        data: {
          sceneId: sceneId as string,
          value: checked,
        },
      },
    });
  }

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <span className={styles.title}>Quest in the scene</span>
        <span className={styles.subtitle}>
          You can activate / deactivate the quest with the switch
        </span>
        <Switch
          checked={isChecked}
          checkedChildren='Enabled'
          unCheckedChildren='Disabled'
          onClick={switchEnableQuest}
        />
      </div>
      <QuestSettings questId={scene?.userScenes[0].questId} sceneId={sceneId} />
    </div>
  );
};

export default Quests;
